<template>
  <label
    :class="cn('tw:relative tw:inline-flex tw:items-center tw:gap-2 tw:m-0', props.class)"
  >
    <RadioInput
      :value="value"
      :disabled="disabled"
      v-bind="$attrs"
    />

    <span
      :class="cn('tw:cursor-pointer', {
        'tw:opacity-50 tw:cursor-not-allowed': disabled,
      })"
    >
      {{ label }}
    </span>
  </label>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils.js'
import RadioInput from './RadioInput.vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  label: {
    type: String,
    require: true,
  },
  value: {
    type: [String, Boolean, Number],
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  class: {
    type: null,
    required: false,
  },
})
</script>
